import { createTransitionStyle } from './createTransitionStyle';
import { getCssProperties } from './getCssProperties';
import { Duration, Style } from './types';
import { applyStyleToElement } from './applyStyleToElement';
import { waitForTransitionToComplete } from './waitForTransitionToComplete';

export const animateToEndStyle = (endStyle: Style, element: HTMLElement, duration: Duration) => {
  const animatedTransition = createTransitionStyle(getCssProperties(endStyle), duration);
  applyStyleToElement({ ...endStyle, ...animatedTransition }, element);
  return waitForTransitionToComplete(element);
};
